/*!
 * ASP.NET SignalR JavaScript Library v2.3.0-rtm
 * http://signalr.net/
 *
 * Copyright (c) .NET Foundation. All rights reserved.
 * Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *
 */

/// <reference path="..\..\SignalR.Client.JS\Scripts\jquery-1.6.4.js" />
/// <reference path="jquery.signalR.js" />
(function ($, window, undefined) {
    /// <param name="$" type="jQuery" />
    "use strict";

    if (typeof ($.signalR) !== "function") {
        throw new Error("SignalR: SignalR is not loaded. Please ensure jquery.signalR-x.js is referenced before ~/signalr/js.");
    }

    var signalR = $.signalR;

    function makeProxyCallback(hub, callback) {
        return function () {
            // Call the client hub method
            callback.apply(hub, $.makeArray(arguments));
        };
    }

    function registerHubProxies(instance, shouldSubscribe) {
        var key, hub, memberKey, memberValue, subscriptionMethod;

        for (key in instance) {
            if (instance.hasOwnProperty(key)) {
                hub = instance[key];

                if (!(hub.hubName)) {
                    // Not a client hub
                    continue;
                }

                if (shouldSubscribe) {
                    // We want to subscribe to the hub events
                    subscriptionMethod = hub.on;
                } else {
                    // We want to unsubscribe from the hub events
                    subscriptionMethod = hub.off;
                }

                // Loop through all members on the hub and find client hub functions to subscribe/unsubscribe
                for (memberKey in hub.client) {
                    if (hub.client.hasOwnProperty(memberKey)) {
                        memberValue = hub.client[memberKey];

                        if (!$.isFunction(memberValue)) {
                            // Not a client hub function
                            continue;
                        }

                        // Use the actual user-provided callback as the "identity" value for the registration.
                        subscriptionMethod.call(hub, memberKey, makeProxyCallback(hub, memberValue), memberValue);
                    }
                }
            }
        }
    }

    $.hubConnection.prototype.createHubProxies = function () {
        var proxies = {};
        this.starting(function () {
            // Register the hub proxies as subscribed
            // (instance, shouldSubscribe)
            registerHubProxies(proxies, true);

            this._registerSubscribedHubs();
        }).disconnected(function () {
            // Unsubscribe all hub proxies when we "disconnect".  This is to ensure that we do not re-add functional call backs.
            // (instance, shouldSubscribe)
            registerHubProxies(proxies, false);
        });

        proxies['AdminHub'] = this.createHubProxy('AdminHub'); 
        proxies['AdminHub'].client = { };
        proxies['AdminHub'].server = {
            displayNotification: function (message, acknowledgePrompt, ids) {
                return proxies['AdminHub'].invoke.apply(proxies['AdminHub'], $.merge(["DisplayNotification"], $.makeArray(arguments)));
             },

            exit: function () {
                return proxies['AdminHub'].invoke.apply(proxies['AdminHub'], $.merge(["Exit"], $.makeArray(arguments)));
             },

            join: function () {
                return proxies['AdminHub'].invoke.apply(proxies['AdminHub'], $.merge(["Join"], $.makeArray(arguments)));
             },

            relaunchApplications: function (app) {
                return proxies['AdminHub'].invoke.apply(proxies['AdminHub'], $.merge(["RelaunchApplications"], $.makeArray(arguments)));
             }
        };

        proxies['AgentLiveViewHub'] = this.createHubProxy('AgentLiveViewHub'); 
        proxies['AgentLiveViewHub'].client = { };
        proxies['AgentLiveViewHub'].server = {
            agentLiveView: function (roomID, agentID, message, debug) {
                return proxies['AgentLiveViewHub'].invoke.apply(proxies['AgentLiveViewHub'], $.merge(["AgentLiveView"], $.makeArray(arguments)));
             },

            join: function () {
                return proxies['AgentLiveViewHub'].invoke.apply(proxies['AgentLiveViewHub'], $.merge(["Join"], $.makeArray(arguments)));
             }
        };

        proxies['ChatHub'] = this.createHubProxy('ChatHub'); 
        proxies['ChatHub'].client = { };
        proxies['ChatHub'].server = {
            getUser: function (chatID, identity) {
                return proxies['ChatHub'].invoke.apply(proxies['ChatHub'], $.merge(["GetUser"], $.makeArray(arguments)));
             },

            join: function (chatID, identity) {
                return proxies['ChatHub'].invoke.apply(proxies['ChatHub'], $.merge(["Join"], $.makeArray(arguments)));
             },

            leave: function (chatID, identity) {
                return proxies['ChatHub'].invoke.apply(proxies['ChatHub'], $.merge(["Leave"], $.makeArray(arguments)));
             },

            sendMessage: function (chatID, identity, type, payload) {
                return proxies['ChatHub'].invoke.apply(proxies['ChatHub'], $.merge(["SendMessage"], $.makeArray(arguments)));
             }
        };

        proxies['CommunicationHub'] = this.createHubProxy('CommunicationHub'); 
        proxies['CommunicationHub'].client = { };
        proxies['CommunicationHub'].server = {
            acknowledgeNotification: function (messageID) {
                return proxies['CommunicationHub'].invoke.apply(proxies['CommunicationHub'], $.merge(["AcknowledgeNotification"], $.makeArray(arguments)));
             },

            join: function (client, application, fullName, email, userID) {
                return proxies['CommunicationHub'].invoke.apply(proxies['CommunicationHub'], $.merge(["Join"], $.makeArray(arguments)));
             }
        };

        proxies['TMHub'] = this.createHubProxy('TMHub'); 
        proxies['TMHub'].client = { };
        proxies['TMHub'].server = {
            join: function () {
                return proxies['TMHub'].invoke.apply(proxies['TMHub'], $.merge(["Join"], $.makeArray(arguments)));
             },

            lockRecord: function (client, identifier, userID) {
                return proxies['TMHub'].invoke.apply(proxies['TMHub'], $.merge(["LockRecord"], $.makeArray(arguments)));
             }
        };

        return proxies;
    };

    signalR.hub = $.hubConnection("/signalr", { useDefaultPath: false });
    $.extend(signalR, signalR.hub.createHubProxies());

}(window.jQuery, window));